// The venue's own UPI QR (F-PAY-02; spec/06 §8.3, §9.1): a `upi://pay` link any UPI app opens, paying the venue's UPI ID
// (`payments.counterUpiVpa`) directly — the Platform never touches the money, and nothing is recorded until staff
// confirm the payment arrived (a `counter_upi` tender).
//
// One builder for both places that draw it: the console's Sell (the counter QR) and the kiosk's "Scan & pay (UPI)"
// (the same QR at the PC, 2026-10-01). The link is NPCI's UPI linking spec, in this order and no more:
//
//   upi://pay?pa=<vpa>&pn=<payee name>&am=<amount in rupees, 2 decimals>&cu=<currency>&tn=<note>
//
// Each value is percent-encoded (`encodeURIComponent`: a space is `%20`, never `+`, which some UPI apps show
// literally). The amount is the integer minor units written as a decimal — never a float sum.
//
// Pure: no I/O, no clock.
/** The minor units written as the major-unit decimal a UPI link carries: 24900 → "249.00". Never a float. */
export function upiAmount(minor) {
    if (!Number.isSafeInteger(minor) || minor < 0)
        throw new RangeError('A UPI amount is a non-negative integer of minor units.');
    const rupees = Math.floor(minor / 100);
    const paise = minor % 100;
    return `${rupees}.${String(paise).padStart(2, '0')}`;
}
/** The `upi://pay` link for the venue's own QR (NPCI's linking spec, the fields in a fixed order). */
export function upiPayUri(link) {
    const fields = [
        ['pa', link.vpa.trim()],
        ['pn', link.payeeName],
        ['am', upiAmount(link.amount.amount)],
        ['cu', link.amount.currency.trim()],
        ['tn', link.note],
    ];
    return `upi://pay?${fields.map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')}`;
}
//# sourceMappingURL=upi.js.map